import { type UseQueryResult, useQuery } from 'react-query';
import { FairMarketValueConfigurationService } from '../../services/wealthlane-award-services';

const useGetFmvConfigSettlementType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const OrderSettlementTypeList = ['Sell To Cover', 'Sell All', 'Withhold To Cover', 'Cash'];
  const fmvConfigSettlementType = useQuery(
    ['getFmvConfigSettlementType'],
    async () => {
      return await handleRequest(
        FairMarketValueConfigurationService.getApiAwardApiAppFairMarketValueConfigurationSettlementTypesForFmvConfiguration()
      );
    },
    {
      select: (data) => {
        return data
          ?.map((item) => {
            return {
              label: item.displayName ?? '',
              value: item.id ?? '',
              systemName: item.systemName ?? '',
            };
          })
          .sort((a, b) => {
            const indexA = OrderSettlementTypeList.indexOf(a.systemName);
            const indexB = OrderSettlementTypeList.indexOf(b.systemName);
            return indexA - indexB;
          });
      },
    }
  );

  return fmvConfigSettlementType;
};

export default useGetFmvConfigSettlementType;
